import { render } from "./AdminCourses.vue?vue&type=template&id=fe420b58&scoped=true"
import script from "./AdminCourses.vue?vue&type=script&lang=js"
export * from "./AdminCourses.vue?vue&type=script&lang=js"

import "./AdminCourses.vue?vue&type=style&index=0&id=fe420b58&scoped=true&lang=scss"

import exportComponent from "D:\\programmazione\\pronails\\MemsionPrivato\\front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fe420b58"]])

export default __exports__